(() => {
  if (window.rcpDrumrCartInstalled) return;
  window.rcpDrumrCartInstalled = true;
  const root = window.Shopify.routes.root;
  const variant = 48965799018614;
  let pending;
  let reloading = false;
  let retries = 0;
  let timer;
  const onCartPage = location.pathname === root + 'cart' || location.pathname === root + 'cart/';
  const giftLines = cart => cart.items.filter(item => item.variant_id === variant);
  const request = async (url, data) => {
    const response = await fetch(url, data ? {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(data)
    } : {credentials:'same-origin', cache:'no-store'});
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  };
  const getState = async () => {
    const url = new URL(root + 'cart', location.origin);
    url.searchParams.set('section_id', 'rcp-drumr-cart-state');
    const response = await fetch(url, {credentials:'same-origin', cache:'no-store'});
    if (!response.ok) throw new Error('Cart eligibility unavailable');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    return JSON.parse(doc.getElementById('rcp-drumr-cart-state').textContent);
  };
  const lock = value => {
    document.querySelectorAll('.cart__ctas, .cart__dynamic-checkout-buttons').forEach(el => {
      el.inert = value;
      el.setAttribute('aria-busy', String(value));
    });
  };
  const reconcile = async () => {
    const state = await getState();
    let cart = state.cart;
    let lines = giftLines(cart);
    let changed = false;
    const updates = {};
    lines.forEach((line,index) => {
      const wanted = state.eligible && index === 0 ? 1 : 0;
      if (line.quantity !== wanted) updates[line.key] = wanted;
    });
    if (Object.keys(updates).length) {
      cart = await request(root + 'cart/update.js', {updates});
      changed = true;
    }
    lines = giftLines(cart);
    if (state.eligible && !lines.length) {
      await request(root + 'cart/add.js', {items:[{id:variant,quantity:1}]});
      cart = await request(root + 'cart.js');
      changed = true;
    }
    lines = giftLines(cart);
    if (state.eligible && lines.some(line => line.final_line_price > 0)) {
      const applications = [...(cart.cart_level_discount_applications || []),
        ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(x=>x.discount_application))];
      const codes = [...(cart.discount_codes || []).map(x=>x.code),
        ...applications.filter(x=>x && x.type==='discount_code').map(x=>x.title),'RCPDRUMRFREE'];
      cart = await request(root + 'cart/update.js', {discount:[...new Set(codes)].join(',')});
      changed = true;
      if (giftLines(cart).some(line => line.final_line_price > 0)) {
        const removals = Object.fromEntries(giftLines(cart).map(line=>[line.key,0]));
        await request(root + 'cart/update.js',{updates:removals});
        throw new Error('Free gift discount could not be confirmed');
      }
    }
    retries = 0;
    if (changed && onCartPage) {
      reloading = true;
      location.reload();
    }
  };
  const sync = () => {
    if (pending || reloading) return pending;
    lock(true);
    pending = reconcile().catch(error => {
      console.warn('Drumr gift:', error.message);
      if (retries++ < 2) timer = setTimeout(sync, 1000 * retries);
    }).finally(() => {
      if (!reloading) lock(false);
      pending = null;
    });
    return pending;
  };
  document.addEventListener('click', event => {
    if ((pending || reloading) && event.target.closest('#checkout, [name="checkout"], .cart__dynamic-checkout-buttons')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },true);
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, sync);
  if (typeof PerformanceObserver !== 'undefined') {
    const observer = new PerformanceObserver(list => {
      if (pending || reloading) return;
      const changed = list.getEntries().some(entry => {
        const url = new URL(entry.name, location.origin);
        return url.origin === location.origin && /\/cart\/(add|change|update)(\.js)?$/.test(url.pathname);
      });
      if (changed) {
        clearTimeout(timer);
        timer = setTimeout(sync, 250);
      }
    });
    observer.observe({type:'resource'});
  }
  window.addEventListener('pageshow',sync);
  sync();
})();